import React from 'react';
import { motion } from 'framer-motion';

/**
 * LiquidProgress - Animated liquid-style progress bar
 * Non-breaking visual enhancement for progress indicators
 * Does not affect progress calculation
 */
const LiquidProgress = ({ progress = 0, className = '' }) => {
  return (
    <div className={`relative w-full h-3 bg-gray-200 rounded-full overflow-hidden ${className}`}>
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-electric-blue via-electric-purple to-electric-pink"
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ 
          duration: 0.6,
          ease: [0.4, 0, 0.2, 1]
        }}
      >
        {/* Liquid wave effect */}
        <motion.div
          className="absolute inset-0 opacity-30"
          style={{
            background: 'repeating-linear-gradient(90deg, transparent, transparent 10px, rgba(255,255,255,0.3) 10px, rgba(255,255,255,0.3) 20px)'
          }}
          animate={{
            x: [0, 20]
          }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'linear'
          }}
        />
      </motion.div>
    </div>
  );
};

export default LiquidProgress;
